module.exports = __webpack_public_path__ + "static/media/BeaconNewIcon.b213d666.svg";